<div class="container-fluid">
  <div class="row mb-3">
    <div class="card shadow-sm p-0">
      <div class="card-header">
        <h3 class="card-title">{{ checklistGroupId ? 'Update Checklist Group' : 'Create Checklist Group' }}</h3>
      </div>
      <div class="card-body">
        <settings-projects-checklist-group-form
          [checklistGroup]="checklistGroup"
          (onSavedData)="onFormSavedData($event)"
        />
      </div>
    </div>
  </div>
</div>
